import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSubSupervisorAuth } from '../context/SubSupervisorAuthContext';
import LoadingScreen from './LoadingScreen';

const RequireSubSupervisorAuth = () => {
  const { subSupervisor, loading } = useSubSupervisorAuth();

  if (loading) return <LoadingScreen />;
  if (!subSupervisor) return <Navigate to="/sub-supervisor/login" replace />;

  return <Outlet />;
};

export default RequireSubSupervisorAuth;
